import { ALERT_AUDIT_ACTION } from '@/entities/alert/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract, type PagePaginationRequestDto } from '../../lib';

const GetAlertAuditResponseDtoSchema = z.array(
  z.object({
    action: z.enum(ALERT_AUDIT_ACTION),
    actionDate: z.string(),
    id: z.number(),
    modifiedBy: z.string(),
    newValue: z.string().nullable(),
    oldValue: z.string().nullable(),
  })
);

export type GetAlertAuditRequestDto = PagePaginationRequestDto<
  {
    alertId: number;
  },
  'createdAt' | 'modifiedBy' | 'action'
>;
export type GetAlertAuditResponseDto = z.infer<
  typeof GetAlertAuditResponseDtoSchema
>;

export const getAlertAudit = (
  params: GetAlertAuditRequestDto,
  config?: AxiosRequestConfig<GetAlertAuditRequestDto>
) => {
  const { alertId, ...sortingParams } = params;
  return api
    .get(`alerts/audit/${alertId}`, {
      params: sortingParams,
      ...config,
    })
    .then(responseContract(GetAlertAuditResponseDtoSchema));
};
